var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgDb1(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 500,
    height: 500,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#fffff1",
      stroke: "none"
    },
    d: "M0 0L0 500L500 500L500 0L0 0z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#eaf185",
      stroke: "none"
    },
    d: "M454 53L454 54L457 54L454 53M441 54L441 55L445 55L441 54z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#ec5464",
      stroke: "none"
    },
    d: "M291 67C293.32 79.6544 320.083 72 330 72C328.898 76.2578 326.312 83.4697 329.179 87.4861C331.166 90.27 335.952 90.1597 339 90.5748C348.608 91.8833 358.453 90.4125 368 89.2855C373.245 88.6664 382.302 90.0553 386.57 86.3966C390.921 82.6677 391.573 72.3637 392 67C403.441 66.9053 415.657 65.9137 427 64.4244C433.198 63.6107 440.528 63.4361 443.667 70.0154C446.273 75.4767 443.029 84.3156 442.08 90C439.295 106.691 436.147 123.328 433.25 140C422.016 204.657 411.455 269.494 399.389 334C396.092 351.624 393.031 369.315 390.08 387C388.96 393.715 388.881 404.655 383.656 409.581C376.91 415.941 361.541 413 353 413C324.411 413 295.67 412 267 412C258.296 412 239.698 415.551 233.707 407.786C229.784 402.703 232.633 394.687 233.586 389C236.212 373.344 238.637 357.659 241.247 342C246.567 310.08 252.922 278.097 257 246C273.836 244.623 287.699 230.028 304 225.428C317.334 221.666 332.228 221.033 346 220.09C352.79 219.625 362.205 221.161 367.895 216.566C376.712 209.448 376.098 188.94 369.914 180.228C365.633 174.196 356.844 178.695 351 178.961C338.201 179.542 327.082 178.069 317.004 169.561C304.885 159.33 297.48 139.131 283 133L283 134C291.721 141.729 276.114 144.371 282 132C261.989 134.254 288.148 156.808 282.242 164.606C279.247 168.561 273.437 168.689 269 169.166C258.183 170.328 247.634 169.917 237 172.735C232.408 173.951 221.23 178.938 229 184C230.054 174.651 238.301 177.516 237 186L282 180L268 188L267 188C263.6 184.28 258.807 189.628 254.985 190.83C244.357 194.174 231.968 195.399 222.015 200.558C214.901 204.246 215.901 210.558 223 213L220 204C227.832 201.574 231.054 206.844 226 213L242 209.4L283 198C272.822 208.279 251.755 209.846 239 217.615C234.633 220.275 228.46 223.82 226.786 229C224.223 236.934 234.765 237.769 239.576 235.167C255.77 226.408 273.002 216.077 290 209C282.289 217.442 264.201 227.339 253 230C252.663 245.81 248.312 262.35 245.754 278C241.179 305.987 236.821 334.013 232.246 362C229.672 377.75 221.096 401.403 225.8 417C230.932 434.013 249.972 431.95 264 432.91C299.615 435.349 336.311 436 372 436C384.768 436 401.505 440.547 411.895 430.787C418.453 424.627 419.056 415.315 420.611 407C423.849 389.688 426.653 372.292 430 355C443.443 285.544 456.057 215.743 467.919 146C470.983 127.984 474.251 109.963 477.611 92C479.584 81.4549 482.134 70.7426 473.892 62.0432C461.612 49.0828 442.564 55.2541 427 55.9606C397.688 57.2913 368.209 60.0488 339 62.8302C323.272 64.328 306.412 63.3307 291 67z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#eaf185",
      stroke: "none"
    },
    d: "M461.667 54.3333L462.333 54.6667L461.667 54.3333M428 55L428 56L432 56L428 55M464 55L465 56L464 55M415 56L415 57L419 57L415 56M466 56L467 57L466 56M122 117L194 99.3734L293 74C287.227 53.0606 267.053 56.4058 250 59.2469C216.48 64.8314 183.648 72.5639 151 81.8596C132.953 86.9978 118.133 96.1701 122 117M402 57L402 58L406 58L402 57M389 58L389 59L393 59L389 58M377 59L377 60L380 60L377 59M364 60L364 61L368 61L364 60M472 60L473 61L472 60M351 61L351 62L355 62L351 61M473 61L474 62L473 61M338 62L338 63L342 63L338 62M474 62L475 63L474 62M325 63L325 64L329 64L325 63M58 64L59 65L58 64z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#23afb3",
      stroke: "none"
    },
    d: "M59 64L59 65L62 65L59 64z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#eaf185",
      stroke: "none"
    },
    d: "M62 64L63 65L62 64M312 64L312 65L316 65L312 64z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#23afb3",
      stroke: "none"
    },
    d: "M392 67C391.27 72.649 390.624 82.6638 385.772 86.3966C382.461 88.9442 376.02 88.8429 372 88.9892C362.009 89.3528 337.495 96.289 329.742 87.4861C326.309 83.5874 329.14 76.4347 330 72L292 74L292 75C296.832 80.8964 297.518 91.6689 299.374 99C303.205 114.13 309.664 128.601 312.385 144C314.937 158.443 307.763 166.711 324 175C331.334 158.563 350.35 163 366 163C371.821 163 380.225 161.416 384.57 166.228C388.095 170.133 388.015 176.077 387.999 181C387.956 194.321 389.021 215.828 383.347 227.985C380.066 235.015 372.554 234.533 366 235.17C353.185 236.415 317.228 242.318 317 223C293.905 223.994 278.548 243.084 257 246C249.812 284.15 244.219 322.69 237.92 361L232.92 392C232.193 396.385 230.477 401.629 232.163 405.957C236.035 415.898 256.528 412 265 412C294.674 412 324.404 413 354 413C362.253 413 379.43 416.258 385.11 408.775C389.108 403.51 389.182 393.375 390.247 387C392.975 370.661 395.685 354.269 398.803 338C410.896 274.913 421.508 211.36 432.08 148C435.255 128.973 438.906 110.025 442.08 91C443.119 84.773 446.734 74.982 443.681 69.044C440.842 63.5203 434.378 63.7216 429 64.0895C416.703 64.9308 404.324 66.7456 392 67M56 65L57 66L56 65z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#2e2c2c",
      stroke: "none"
    },
    d: "M57.0394 65.7423C47.8774 69.3058 41.3181 79.4007 42.0934 89C42.4654 93.607 47.1899 104.905 53.6628 102.338C58.9549 100.239 47.8221 93.459 51.6474 89.6921C53.4796 87.8879 56.6972 89.0555 58.8958 87.9337C62.1886 86.2535 63.2314 81.9202 67.0432 81.0417C73.3457 79.589 80.0315 82.957 85.412 77.3619C87.5506 75.138 87.6203 71.9784 84.767 70.3326C81.5125 68.4553 77.5058 70.2318 74 69.6451C68.1586 68.6674 63.327 63.2967 57.0394 65.7423z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#23afb3",
      stroke: "none"
    },
    d: "M64 65L65 66L64 65z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#eaf185",
      stroke: "none"
    },
    d: "M65 65L66 66L65 65M300 65L300 66L303 66L300 65M54 66L55 67L54 66z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#23afb3",
      stroke: "none"
    },
    d: "M66 66L67 67L66 66z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#eaf185",
      stroke: "none"
    },
    d: "M53 67L54 68L53 67M68 67L69 68L68 67z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#23afb3",
      stroke: "none"
    },
    d: "M69 68L70 69L69 68z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#eaf185",
      stroke: "none"
    },
    d: "M52 69L53 70L52 69z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#23afb3",
      stroke: "none"
    },
    d: "M72 69L73 70L72 69z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#eaf185",
      stroke: "none"
    },
    d: "M73 69L73 70L77 70L73 69z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#23afb3",
      stroke: "none"
    },
    d: "M77 69L77 70L80 70L77 69M83 69L84 70L83 69z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#eaf185",
      stroke: "none"
    },
    d: "M84 69L85 70L84 69z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#2e2c2c",
      stroke: "none"
    },
    d: "M463 69C463 101.825 455.23 134.812 449.424 167C442.055 207.856 435.854 248.352 427.211 289C422.111 312.984 415.073 336.836 411.08 361C408.352 377.512 408.496 397.267 399.647 411.996C394.833 420.01 384.828 419.628 380 426C415.162 424.389 410.995 368.533 417.127 344C431.953 284.68 442.952 225.384 452.275 165C457.19 133.161 465 101.355 465 69L463 69z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#eaf185",
      stroke: "none"
    },
    d: "M478 69L479 70L478 69M51 70L52 71L51 70M86 70L87 71L86 70M49 71L50 72L49 71M87 71L88 72L87 71z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#23afb3",
      stroke: "none"
    },
    d: "M48 72L49 73L48 72M87 72L88 73L87 72z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#eaf185",
      stroke: "none"
    },
    d: "M479 72L480 73L479 72M87 75L88 76L87 75z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#23afb3",
      stroke: "none"
    },
    d: "M288 75L289 76L288 75z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#2e2c2c",
      stroke: "none"
    },
    d: "M122 118L129 145L134 147L136 147C139.363 140.682 142.912 134.411 150 132L149 140L301 106L294 75C269.551 76.066 242.652 86.8972 219 93.1157C187.189 101.48 152.719 106.241 122 118z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#23afb3",
      stroke: "none"
    },
    d: "M44 76L45 77L44 76M86 76L87 77L86 76M284 76L285 77L284 76z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#eaf185",
      stroke: "none"
    },
    d: "M43 77L44 78L43 77z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#23afb3",
      stroke: "none"
    },
    d: "M280 77L281 78L280 77M43 78L44 79L43 78M84 78L85 79L84 78M276 78L277 79L276 78M82 79L83 80L82 79z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#eaf185",
      stroke: "none"
    },
    d: "M83 79L84 80L83 79z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#23afb3",
      stroke: "none"
    },
    d: "M272 79L273 80L272 79z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#eaf185",
      stroke: "none"
    },
    d: "M42 80L43 81L42 80z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#ec5464",
      stroke: "none"
    },
    d: "M140 171L116.015 180.221L106 191C103.376 177.484 93.5695 188.128 85 186.35C74.1016 184.089 59.0218 176.625 52 168C61.4711 174.389 75.1202 184.201 87 184.721C92.787 184.975 99.5213 181.709 105 180.025C119.457 175.579 134.401 169.115 148.715 165.295C154.166 163.84 161.287 167.878 167 168C166.472 161.225 161.291 162.732 157 159L177 161C173.533 154.126 164.765 155.001 158 155L158 153C162.188 153.003 174.312 156.405 176.914 152.515C178.978 149.427 174.169 147.429 171.995 146.789C166.164 145.074 159.796 146.908 154 148L174 141C165.716 136.945 157.714 138.358 149 140L150 132C142.562 133.502 138.47 140.253 136 147L134 147C131.067 142.478 126.152 145.113 122 146.848C113.564 150.374 101.32 157.108 92 156.588C87.4191 156.333 82.681 152.104 79 149.645C69.4903 143.294 60.5715 135.555 50 131L50 130C65.1078 135.238 78.009 153.929 94 155L86 134L96 154L112 150L112 149C97.8138 146.247 96.6569 135.76 87.6998 126.055C81.0709 118.872 73.7824 115.204 71 105L77 99L71 99C73.2313 98.2583 76.9717 97.8874 78.0378 95.4275C80.659 89.3798 72.8279 78.7968 66.1042 80.7739C63.1561 81.6408 62.0242 84.8304 59.7909 86.6435C57.3213 88.6485 52.8792 87.2507 51.0432 89.6173C48.1071 93.4018 54.1716 97.6936 55.1265 101.011C56.1722 104.643 53.8698 108.799 52.3156 112C48.4473 119.966 38.6506 123.546 35.1335 132C29.0086 146.723 40.4476 164.253 42.7253 179C43.5169 184.125 42.7597 192.609 46.5139 196.57C55.207 205.743 82.5016 203.195 93 199.073C98.4679 196.927 103.379 192.051 109.424 191.88C116.921 191.667 133.324 198.087 139.382 192.142C142.561 189.022 138.807 176.011 140 171z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#23afb3",
      stroke: "none"
    },
    d: "M80 80L81 81L80 80z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#eaf185",
      stroke: "none"
    },
    d: "M81 80L82 81L81 80z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#23afb3",
      stroke: "none"
    },
    d: "M268 80L269 81L268 80M74 81L74 82L78 82L74 81z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#eaf185",
      stroke: "none"
    },
    d: "M78 81L79 82L78 81z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#23afb3",
      stroke: "none"
    },
    d: "M264 81L265 82L264 81z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#eaf185",
      stroke: "none"
    },
    d: "M479.333 81.6667L479.667 82.3333L479.333 81.6667M74 82L75 83L74 82z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#23afb3",
      stroke: "none"
    },
    d: "M260 82L261 83L260 82z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#eaf185",
      stroke: "none"
    },
    d: "M41 83L41 86L42 86L41 83z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#23afb3",
      stroke: "none"
    },
    d: "M256 83L257 84L256 83z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#eaf185",
      stroke: "none"
    },
    d: "M75 84L76 85L75 84z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#23afb3",
      stroke: "none"
    },
    d: "M252 84L253 85L252 84M248 85L249 86L248 85M41 86L42 87L41 86z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#eaf185",
      stroke: "none"
    },
    d: "M76.3333 86.6667L76.6667 87.3333L76.3333 86.6667z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#23afb3",
      stroke: "none"
    },
    d: "M244 86L245 87L244 86z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#eaf185",
      stroke: "none"
    },
    d: "M41 87L41 90L42 90L41 87z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#23afb3",
      stroke: "none"
    },
    d: "M240 87L241 88L240 87z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#eaf185",
      stroke: "none"
    },
    d: "M478.333 87.6667L478.667 88.3333L478.333 87.6667z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#23afb3",
      stroke: "none"
    },
    d: "M236 88L237 89L236 88z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#eaf185",
      stroke: "none"
    },
    d: "M77.3333 89.6667L77.6667 90.3333L77.3333 89.6667z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#23afb3",
      stroke: "none"
    },
    d: "M232 89L233 90L232 89M228 90L229 91L228 90M42 92L43 93L42 92z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#eaf185",
      stroke: "none"
    },
    d: "M78 92L79 93L78 92z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#23afb3",
      stroke: "none"
    },
    d: "M221 92L222 93L221 92z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#eaf185",
      stroke: "none"
    },
    d: "M477.333 92.6667L477.667 93.3333L477.333 92.6667M42 93L43 94L42 93z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#2e2c2c",
      stroke: "none"
    },
    d: "M69 93L67 96L71 98L69 93z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#23afb3",
      stroke: "none"
    },
    d: "M217 93L218 94L217 93z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#eaf185",
      stroke: "none"
    },
    d: "M79 94L80 95L79 94z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#23afb3",
      stroke: "none"
    },
    d: "M213 94L214 95L213 94z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#eaf185",
      stroke: "none"
    },
    d: "M43 95L44 96L43 95z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#23afb3",
      stroke: "none"
    },
    d: "M209 95L210 96L209 95z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#eaf185",
      stroke: "none"
    },
    d: "M77.3333 96.6667L77.6667 97.3333L77.3333 96.6667z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#23afb3",
      stroke: "none"
    },
    d: "M205 96L206 97L205 96z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#eaf185",
      stroke: "none"
    },
    d: "M44 97L45 98L44 97z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#23afb3",
      stroke: "none"
    },
    d: "M201 97L202 98L201 97z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#eaf185",
      stroke: "none"
    },
    d: "M45 98L46 99L45 98z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#2e2c2c",
      stroke: "none"
    },
    d: "M71 98L71 99L77 99L71 98z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#23afb3",
      stroke: "none"
    },
    d: "M197 98L198 99L197 98z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#eaf185",
      stroke: "none"
    },
    d: "M476.333 98.6667L476.667 99.3333L476.333 98.6667M46 99L47 100L46 99z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#23afb3",
      stroke: "none"
    },
    d: "M193 99L194 100L193 99z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#eaf185",
      stroke: "none"
    },
    d: "M47 100L48 101L47 100M76 100L77 101L76 100z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#23afb3",
      stroke: "none"
    },
    d: "M189 100L190 101L189 100z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#eaf185",
      stroke: "none"
    },
    d: "M48 101L49 102L48 101z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#23afb3",
      stroke: "none"
    },
    d: "M185 101L186 102L185 101z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#eaf185",
      stroke: "none"
    },
    d: "M49 102L50 103L49 102M75 102L76 103L75 102z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#23afb3",
      stroke: "none"
    },
    d: "M181 102L182 103L181 102z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#eaf185",
      stroke: "none"
    },
    d: "M51 103L52 104L51 103z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#23afb3",
      stroke: "none"
    },
    d: "M52.6667 103.333L53.3333 103.667L52.6667 103.333z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#eaf185",
      stroke: "none"
    },
    d: "M54 103L55 107L56 107L54 103M74 103L75 104L74 103z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#23afb3",
      stroke: "none"
    },
    d: "M177 103L178 104L177 103z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#eaf185",
      stroke: "none"
    },
    d: "M73 104L74 105L73 104z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#23afb3",
      stroke: "none"
    },
    d: "M173 104L174 105L173 104z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#eaf185",
      stroke: "none"
    },
    d: "M475 104L476 105L475 104M71.3333 105.667L71.6667 106.333L71.3333 105.667z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#23afb3",
      stroke: "none"
    },
    d: "M169 105L170 106L169 105M165 106L166 107L165 106M297 106L298 107L297 106z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#eaf185",
      stroke: "none"
    },
    d: "M171 138L174 141L168 145L168 146C172.056 146.964 180.931 150.102 174 154L177 161C171.967 162.633 167.497 161.773 167 168C158.783 167.624 150.506 161.91 143.109 167.79C132.478 176.242 141.145 199.234 153 201.941C162.012 204 172.272 199.349 181 197.424C198.434 193.579 218.195 188.767 236 188L236 187C226.241 186.285 224.118 177.314 234 173.904C245.58 169.907 257.107 170.746 269 169.285C273.351 168.75 279.067 168.987 282.257 165.351C287.478 159.401 276.769 148.123 275.25 142C274.311 138.215 275.26 133.14 280.019 132.777C293.698 131.734 300.163 157.513 311 163C317.467 142.598 304.888 125.555 302 106C257.627 109.624 215.095 132.062 171 138z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#23afb3",
      stroke: "none"
    },
    d: "M161 107L162 108L161 107M293 107L294 108L293 107M157 108L158 109L157 108M289 108L290 109L289 108z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#eaf185",
      stroke: "none"
    },
    d: "M72 109L72 112L73 112L72 109z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#23afb3",
      stroke: "none"
    },
    d: "M153 109L154 110L153 109M285 109L286 110L285 109z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#eaf185",
      stroke: "none"
    },
    d: "M474.333 109.667L474.667 110.333L474.333 109.667z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#23afb3",
      stroke: "none"
    },
    d: "M149 110L150 111L149 110M281 110L282 111L281 110M145 111L146 112L145 111M277 111L278 112L277 111z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#eaf185",
      stroke: "none"
    },
    d: "M52 112L53 113L52 112M74 112L75 113L74 112z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#23afb3",
      stroke: "none"
    },
    d: "M141 112L142 113L141 112M273 112L274 113L273 112M137 113L138 114L137 113M269 113L270 114L269 113M133 114L134 115L133 114M265 114L266 115L265 114z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#2e2c2c",
      stroke: "none"
    },
    d: "M52 115L52 116L67 130L68 130L72 122L80 126C75.2149 119.427 71.1545 119.564 68 127C63.3163 121.957 58.9504 116.648 52 115z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#23afb3",
      stroke: "none"
    },
    d: "M261 115L262 116L261 115z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#eaf185",
      stroke: "none"
    },
    d: "M473 115L474 116L473 115M49 116L50 117L49 116z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#23afb3",
      stroke: "none"
    },
    d: "M126 116L127 117L126 116M257 116L258 117L257 116M122 117L123 118L122 117M253 117L254 118L253 117M249 118L250 119L249 118M122 119L123 120L122 119M245 119L246 120L245 119z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#eaf185",
      stroke: "none"
    },
    d: "M79 120L80 121L79 120M122 120L123 121L122 120z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#23afb3",
      stroke: "none"
    },
    d: "M241 120L242 121L241 120z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#eaf185",
      stroke: "none"
    },
    d: "M472.333 120.667L472.667 121.333L472.333 120.667M43 121L44 122L43 121M81 121L82 122L81 121z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#23afb3",
      stroke: "none"
    },
    d: "M237 121L238 122L237 121z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#eaf185",
      stroke: "none"
    },
    d: "M42 122L43 123L42 122z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#23afb3",
      stroke: "none"
    },
    d: "M233 122L234 123L233 122z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#eaf185",
      stroke: "none"
    },
    d: "M41 123L42 124L41 123z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#23afb3",
      stroke: "none"
    },
    d: "M123 123L124 124L123 123M229 123L230 124L229 123z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#eaf185",
      stroke: "none"
    },
    d: "M40 124L41 125L40 124M123 124L124 125L123 124z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#23afb3",
      stroke: "none"
    },
    d: "M225 124L226 125L225 124z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#eaf185",
      stroke: "none"
    },
    d: "M39 125L40 126L39 125z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#23afb3",
      stroke: "none"
    },
    d: "M221 125L222 126L221 125M217 126L218 127L217 126z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#eaf185",
      stroke: "none"
    },
    d: "M471 126L472 127L471 126z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#23afb3",
      stroke: "none"
    },
    d: "M124 127L125 128L124 127M213 127L214 128L213 127z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#eaf185",
      stroke: "none"
    },
    d: "M89 128L90 129L89 128M124 128L125 129L124 128z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#23afb3",
      stroke: "none"
    },
    d: "M209 128L210 129L209 128M205 129L206 130L205 129z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#2e2c2c",
      stroke: "none"
    },
    d: "M50 130L50 131C66.5735 141.145 82.9377 160.234 103 154.025C107.095 152.758 112.315 152.543 115 149L96 154C94.5336 147.826 91.4501 137.573 86 134L94 155C77.5383 152.811 66.3427 133.918 50 130z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#23afb3",
      stroke: "none"
    },
    d: "M201 130L202 131L201 130M125 131L126 132L125 131M198 131L199 132L198 131z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#eaf185",
      stroke: "none"
    },
    d: "M470.333 131.667L470.667 132.333L470.333 131.667M92 132L93 133L92 132M125 132L126 133L125 132z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#23afb3",
      stroke: "none"
    },
    d: "M194 132L195 133L194 132z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#eaf185",
      stroke: "none"
    },
    d: "M34 133L35 134L34 133z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#23afb3",
      stroke: "none"
    },
    d: "M190 133L191 134L190 133z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#2e2c2c",
      stroke: "none"
    },
    d: "M282.104 134.176C277.031 134.882 280.046 143.612 284.686 142.248C288.793 141.042 285.995 133.635 282.104 134.176z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#23afb3",
      stroke: "none"
    },
    d: "M186 134L187 135L186 134M126 135L127 136L126 135M182 135L183 136L182 135z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#ec5464",
      stroke: "none"
    },
    d: "M282 135C281.216 138.43 281.578 139.864 285 141L282 135z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#eaf185",
      stroke: "none"
    },
    d: "M33.3333 136.667L33.6667 137.333L33.3333 136.667M126.333 136.667L126.667 137.333L126.333 136.667z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#23afb3",
      stroke: "none"
    },
    d: "M178 136L179 137L178 136z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#eaf185",
      stroke: "none"
    },
    d: "M95 137L96 138L95 137z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#23afb3",
      stroke: "none"
    },
    d: "M174 137L175 138L174 137z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#eaf185",
      stroke: "none"
    },
    d: "M469 137L470 138L469 137z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#23afb3",
      stroke: "none"
    },
    d: "M170 138L171 139L170 138M127 140L128 141L127 140z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#eaf185",
      stroke: "none"
    },
    d: "M127 141L128 142L127 141M98 142L99 143L98 142M468.333 142.667L468.667 143.333L468.333 142.667M33 144L34 145L33 144z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#2e2c2c",
      stroke: "none"
    },
    d: "M154 148L168 146C164.016 142.997 157.044 143.984 154 148z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#eaf185",
      stroke: "none"
    },
    d: "M100 145L101 146L100 145M101 146L102 147L101 146M104.667 147.333L105.333 147.667L104.667 147.333M109 148L110 149L109 148M467 148L468 149L467 148M34 149L35 150L34 149M35 152L36 153L35 152z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#2e2c2c",
      stroke: "none"
    },
    d: "M158 153L158 155L174 156L158 153z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#eaf185",
      stroke: "none"
    },
    d: "M466.333 153.667L466.667 154.333L466.333 153.667M36 155L37 156L36 155M37 158L38 159L37 158z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#2e2c2c",
      stroke: "none"
    },
    d: "M157 159L169 163L157 159z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#eaf185",
      stroke: "none"
    },
    d: "M465 159L466 160L465 159M38 161L39 162L38 161M325 176C327.44 173.079 328.457 169.091 332.044 167.179C340.367 162.742 354.836 166.362 364 165.961C369.785 165.707 377.862 162.895 382.697 167.434C386.221 170.742 386.149 176.541 385.961 181C385.454 193.013 387.944 219.272 380.347 228.867C376.249 234.042 369.764 232.621 364 233.17C352.305 234.283 321.565 239.095 319 223L317 223C317.068 242.275 352.724 236.878 366 235.285C370.589 234.735 375.759 235.386 379.891 232.86C383.944 230.384 384.625 225.3 385.385 221C387.439 209.377 387.696 195.828 387.985 184C388.125 178.318 389.029 169.821 384.57 165.434C378.626 159.585 359.868 163 352 163C341.536 163 324.033 160.918 325 176M39 164L40 165L39 164M464.333 164.667L464.667 165.333L464.333 164.667z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#23afb3",
      stroke: "none"
    },
    d: "M326 176C334.33 179.538 344.069 179.564 353 178.91C357.738 178.562 363.452 175.549 367.775 178.743C377.874 186.203 376.049 210.83 365.985 217.258C360.459 220.786 352.24 219.766 346 220.039C336.925 220.437 328.143 222 319 222C319.803 239.278 351.959 234.706 364 233.285C367.918 232.823 372.172 233.555 375.985 232.427C380.067 231.22 381.964 227.916 382.956 224C386.154 211.38 385.389 195.078 385.961 182C386.155 177.551 386.724 170.972 383.436 167.434C379.239 162.917 370.305 165.325 365 165.83C351.792 167.087 330.789 159.657 326 176z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#eaf185",
      stroke: "none"
    },
    d: "M40 168L41 169L40 168z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#2e2c2c",
      stroke: "none"
    },
    d: "M52 168C56.7869 176.882 76.0634 185.801 86 186.75C94.7993 187.59 102.113 178.87 106 191L119 178.93L140 171L140 170C123.158 172.487 103.925 185.38 87 184.487C74.4852 183.826 62.8037 173.111 52 168z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#eaf185",
      stroke: "none"
    },
    d: "M463 170L464 171L463 170M41 172L42 173L41 172M462.333 175.667L462.667 176.333L462.333 175.667M42.3333 177.667L42.6667 178.333L42.3333 177.667z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#2e2c2c",
      stroke: "none"
    },
    d: "M282 180L237 186C239.706 174.049 225.924 177.041 229.607 184.566C231.262 187.947 238.778 187.82 242 187.961C251.654 188.383 275.924 188.71 282 180z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#ec5464",
      stroke: "none"
    },
    d: "M231 179L232 185L236 184L236 179L231 179z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#eaf185",
      stroke: "none"
    },
    d: "M461 181L462 182L461 181M43.3333 184.667L43.6667 185.333L43.3333 184.667z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#23afb3",
      stroke: "none"
    },
    d: "M267 188L272 186L267 188M230 186L231 187L230 186z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#eaf185",
      stroke: "none"
    },
    d: "M460.333 186.667L460.667 187.333L460.333 186.667z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#23afb3",
      stroke: "none"
    },
    d: "M236.667 187.333L237.333 187.667L236.667 187.333M254.667 187.333L255.333 187.667L254.667 187.333z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#eaf185",
      stroke: "none"
    },
    d: "M256 187L256 188L259 188L256 187M260 187L261 188L260 187M259 189L260 190L259 189M255.667 190.333L256.333 190.667L255.667 190.333M108 191L109 192L108 191M251.667 191.333L252.333 191.667L251.667 191.333z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#23afb3",
      stroke: "none"
    },
    d: "M51 199C47.4129 227.384 57.4478 250.494 68.5756 276C71.6755 283.105 77.3794 303.574 85.1049 306.357C89.0621 307.783 94.9377 305.516 99 305L99 308L84 308L83 308C82.3772 316.447 73.9091 325.971 69.3434 333C59.6695 347.893 49.5936 363.569 42.7315 380C39.889 386.806 32.7528 402.616 41.1335 407.86C52.1272 414.74 70.6352 408.056 83 411L82 409L83 409L93.49 406.682L98.8719 394L111 365L112 365C112 377.986 110.276 391.732 115 404C128.104 404.426 154.024 408.336 164.347 397.431C167.869 393.711 167 387.686 167 383C167 370.141 167.103 356.744 165.424 344C162.659 323.002 161.837 301.31 155.255 281C149.771 264.08 140.174 248.803 132.247 233C126.43 221.404 118.518 201.776 108.24 193.622C103.853 190.142 95.3765 197.907 91 199.452C77.8468 204.095 64.2111 201.562 51 199z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#eaf185",
      stroke: "none"
    },
    d: "M117.667 192.333L118.333 192.667L117.667 192.333M247.667 192.333L248.333 192.667L247.667 192.333M459 192L460 193L459 192M44 193L45 194L44 193M108 193L109 194L108 193M124 193L125 194L124 193M137 193L138 194L137 193M243.667 193.333L244.333 193.667L243.667 193.333M131 194L131 195L134 195L131 194M240.667 194.333L241.333 194.667L240.667 194.333M237 195L238 196L237 195M110 196L111 197L110 196M233.667 196.333L234.333 196.667L233.667 196.333M46 197L47 198L46 197M230.667 197.333L231.333 197.667L230.667 197.333M458.333 197.667L458.667 198.333L458.333 197.667M48 198L49 199L48 198M226.667 198.333L227.333 198.667L226.667 198.333z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#2e2c2c",
      stroke: "none"
    },
    d: "M227 214L227 215L269 205.279L283 198L227 214z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#eaf185",
      stroke: "none"
    },
    d: "M112 199L113 200L112 199M223.667 199.333L224.333 199.667L223.667 199.333M221 200L222 201L221 200M50 202L51 203L50 202M218 202L219 203L218 202z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#2e2c2c",
      stroke: "none"
    },
    d: "M220 204L223 213C233.128 210.932 229.266 199.764 220 204z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#eaf185",
      stroke: "none"
    },
    d: "M457 203L458 204L457 203M115 204L116 205L115 204z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#ec5464",
      stroke: "none"
    },
    d: "M223 204L224 210C228.773 208.398 227.011 205.219 223 204z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#eaf185",
      stroke: "none"
    },
    d: "M216 205L217 206L216 205z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#2e2c2c",
      stroke: "none"
    },
    d: "M70 206C71.6815 217.446 67.4834 221.427 65 232C74.4253 227.364 76.5331 214.648 72 206L70 206z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#eaf185",
      stroke: "none"
    },
    d: "M49 207L49 221L50 221L49 207M117 207L118 208L117 207z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#23afb3",
      stroke: "none"
    },
    d: "M255 208L256 209L255 208z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#eaf185",
      stroke: "none"
    },
    d: "M456.333 208.667L456.667 209.333L456.333 208.667M216 209L217 210L216 209z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#23afb3",
      stroke: "none"
    },
    d: "M250 209L251 210L250 209z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#eaf185",
      stroke: "none"
    },
    d: "M251 209L253 211L253 209L251 209z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#fffff1",
      stroke: "none"
    },
    d: "M253 209L254 210L253 209z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#eaf185",
      stroke: "none"
    },
    d: "M254 209L255 210L254 209z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#2e2c2c",
      stroke: "none"
    },
    d: "M240 236C253.678 232.061 266.154 225.035 278 217.345C282.026 214.731 287.486 213.157 290 209C278.042 212.445 269.291 221.627 258 226.384C251.95 228.933 243.446 229.928 240 236z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#eaf185",
      stroke: "none"
    },
    d: "M119 210L120 211L119 210M217 210L218 211L217 210z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#23afb3",
      stroke: "none"
    },
    d: "M244.667 210.333L245.333 210.667L244.667 210.333z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#eaf185",
      stroke: "none"
    },
    d: "M246 210L247 211L246 210M218 211L219 212L218 211z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#23afb3",
      stroke: "none"
    },
    d: "M240 211L241 212L240 211z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#eaf185",
      stroke: "none"
    },
    d: "M241 211L242 212L241 211M249.667 211.333L250.333 211.667L249.667 211.333M120 212L121 213L120 212M220 212L221 213L220 212z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#ec5464",
      stroke: "none"
    },
    d: "M236 212L237 213L236 212z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#eaf185",
      stroke: "none"
    },
    d: "M237 212L238 213L237 212M248 212L249 213L248 212M222 213L222 214L227 214L222 213M233 213L234 214L233 213M246 213L247 214L246 213z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#23afb3",
      stroke: "none"
    },
    d: "M230 214L231 215L230 214z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#eaf185",
      stroke: "none"
    },
    d: "M231 214L232 215L231 214M244 214L245 215L244 214M455 214L456 215L455 214M122 215L123 216L122 215M227.667 215.333L228.333 215.667L227.667 215.333M242 215L243 216L242 215M240 216L241 217L240 216M239 217L240 218L239 217M237 218L238 219L237 218M454.333 219.667L454.667 220.333L454.333 219.667M125 220L126 221L125 220M234 220L235 221L234 220M233 221L234 222L233 221M126 222L127 223L126 222M230 223L231 224L230 223M127 224L128 225L127 224M229 224L230 225L229 224M50.3333 225.667L50.6667 226.333L50.3333 225.667M228 225L229 226L228 225M453.333 225.667L453.667 226.333L453.333 225.667M227 226L228 227L227 226z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#2e2c2c",
      stroke: "none"
    },
    d: "M230 228C236.577 242.776 245.147 222.532 230 228z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#eaf185",
      stroke: "none"
    },
    d: "M226 228L227 229L226 228z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#ec5464",
      stroke: "none"
    },
    d: "M233 229L238 233C237.419 229.51 236.56 228.453 233 229z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#eaf185",
      stroke: "none"
    },
    d: "M130 229L131 230L130 229M51 230L52 231L51 230M225.333 230.667L225.667 231.333L225.333 230.667M452.333 230.667L452.667 231.333L452.333 230.667z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#2e2c2c",
      stroke: "none"
    },
    d: "M104 231C105.461 247.634 117.701 267.672 124.425 283C126.545 287.833 131.128 292.696 131.732 298C132.401 303.875 128.05 310.466 126.424 316C122.068 330.831 115.341 347.637 114 363C121.713 358.298 122.912 340.278 125.151 332C127.86 321.986 134.389 310.16 135.171 300C135.646 293.823 130.371 287.317 127.756 282C122.024 270.342 117.677 257.948 112.579 246C110.424 240.95 108.742 234.106 104 231z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#eaf185",
      stroke: "none"
    },
    d: "M131 231L132 232L131 231z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#ec5464",
      stroke: "none"
    },
    d: "M251 231L252 232L251 231z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#eaf185",
      stroke: "none"
    },
    d: "M252 231L253 232L252 231z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#ec5464",
      stroke: "none"
    },
    d: "M248 232L249 233L248 232z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#eaf185",
      stroke: "none"
    },
    d: "M249 232L250 233L249 232M132 233L133 234L132 233M226 233L227 234L226 233M246.667 233.333L247.333 233.667L246.667 233.333M52 234L53 235L52 234M244 234L245 235L244 234M133 235L134 236L133 235M242 235L243 236L242 235M252.333 235.667L252.667 236.333L252.333 235.667M229.667 236.333L230.333 236.667L229.667 236.333M236 236L236 237L239 237L236 236z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#2e2c2c",
      stroke: "none"
    },
    d: "M255 238C262.132 252.455 270.75 230.433 255 238z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#eaf185",
      stroke: "none"
    },
    d: "M451.333 236.667L451.667 237.333L451.333 236.667M134 237L135 238L134 237M53 238L54 239L53 238z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#ec5464",
      stroke: "none"
    },
    d: "M258 239L263 242L264 239L258 239z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#eaf185",
      stroke: "none"
    },
    d: "M135 239L136 240L135 239M251 239L252 240L251 239M54 241L55 242L54 241M136 241L137 242L136 241M450.333 241.667L450.667 242.333L450.333 241.667M55 244L56 245L55 244M56 247L57 248L56 247M449.333 247.667L449.667 248.333L449.333 247.667M250.333 248.667L250.667 249.333L250.333 248.667M141 250L142 251L141 250M58 252L59 253L58 252M142 252L143 253L142 252M448 253L449 254L448 253M143 254L144 255L143 254M249.333 254.667L249.667 255.333L249.333 254.667M59 255L60 256L59 255M144 256L145 257L144 256M60 257L61 258L60 257M145 258L146 259L145 258M447.333 258.667L447.667 259.333L447.333 258.667M61 260L62 261L61 260M146 260L147 261L146 260M248.333 260.667L248.667 261.333L248.333 260.667M62 262L63 263L62 262M147 262L148 263L147 262M63 264L64 265L63 264M148 264L149 265L148 264M446 264L447 265L446 264M149 266L150 267L149 266M247.333 266.667L247.667 267.333L247.333 266.667M65 269L66 270L65 269M445.333 269.667L445.667 270.333L445.333 269.667M66 271L67 272L66 271M151 271L152 272L151 271M246.333 272.667L246.667 273.333L246.333 272.667M67 273L68 274L67 273M152 273L153 274L152 273M68 275L69 276L68 275M444 275L445 276L444 275M153 276L154 277L153 276M245 279L246 280L245 279M70 280L71 281L70 280M443.333 280.667L443.667 281.333L443.333 280.667M155 281L156 282L155 281M71 282L72 283L71 282M72 284L73 285L72 284M156 285L157 286L156 285M244.333 285.667L244.667 286.333L244.333 285.667M73 286L74 287L73 286M442 286L443 287L442 286M74 288L75 289L74 288M157 288L158 289L157 288M243.333 291.667L243.667 292.333L243.333 291.667M441.333 291.667L441.667 292.333L441.333 291.667M158.333 292.667L158.667 293.333L158.333 292.667M159.333 297.667L159.667 298.333L159.333 297.667M242.333 297.667L242.667 298.333L242.333 297.667M440 297L441 298L440 297M339 348L345 364L286 365L286 367L347 366L340 347C351.934 340.227 356.199 316.301 363.363 305.059C366.095 300.772 371.181 301.704 374 298C369.853 298.012 365.602 297.779 362.649 301.228C359.457 304.957 359.288 312.192 353.895 313.682C349.499 314.896 344.454 313.122 340 313.015C329.834 312.77 320.225 313.709 310 312.849C304.832 312.414 295.705 310.597 291.518 314.589C287.601 318.323 290.741 326.409 291.421 331C292.056 335.286 291.844 342.904 294.938 346.258C297.562 349.102 303.545 347.963 307 348.004C317.714 348.131 328.241 348 339 348M160 302L160 305L161 305L160 302M439.333 302.667L439.667 303.333L439.333 302.667M241.333 303.667L241.667 304.333L241.333 303.667z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#2e2c2c",
      stroke: "none"
    },
    d: "M84 307L84 310L99 308L99 305L84 307z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#eaf185",
      stroke: "none"
    },
    d: "M83 306L84 307L83 306M438 308L439 309L438 308M161.333 309.667L161.667 310.333L161.333 309.667M240.333 309.667L240.667 310.333L240.333 309.667M83 311L84 312L83 311M437.333 313.667L437.667 314.333L437.333 313.667M80 315L81 316L80 315z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#23afb3",
      stroke: "none"
    },
    d: "M311 325L311 315C306.637 315 297.161 313.21 293.603 316.028C291.213 317.921 291.61 322.877 294.318 324.258C298.622 326.452 306.26 325 311 325z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#eaf185",
      stroke: "none"
    },
    d: "M162 316L162 319L163 319L162 316M239 316L240 317L239 316z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#23afb3",
      stroke: "none"
    },
    d: "M313 316L313 325L331 325L333 316L313 316M333 325C343.156 326.284 350.95 328.118 355 317C345.537 314.203 334.456 313.804 333 325z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#eaf185",
      stroke: "none"
    },
    d: "M78 318L79 319L78 318M436 319L437 320L436 319M76 321L77 322L76 321M238.333 322.667L238.667 323.333L238.333 322.667M75 323L76 324L75 323M163 324L163 327L164 327L163 324M435.333 324.667L435.667 325.333L435.333 324.667M73 326L74 327L73 326z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#23afb3",
      stroke: "none"
    },
    d: "M293 326L294 335L311 334L311 327L293 326M313 327L313 334L330 334L330 327L313 327M333 327L332 334C339.01 333.549 345.859 335.845 349 328L333 327z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#eaf185",
      stroke: "none"
    },
    d: "M72 328L73 329L72 328M237.333 328.667L237.667 329.333L237.333 328.667M434 330L435 331L434 330M70 331L71 332L70 331M164 332L164 335L165 335L164 332M68 334L69 335L68 334M236.333 334.667L236.667 335.333L236.333 334.667M433.333 335.667L433.667 336.333L433.333 335.667z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#23afb3",
      stroke: "none"
    },
    d: "M313 337L313 346C322.239 346 328.762 347.111 329 336L313 337M330 346C338.038 345.995 342.46 344.629 344 336C334.683 336 331.268 336.03 330 346M295 337C295.292 349.039 310.887 349.489 311 337L295 337z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#eaf185",
      stroke: "none"
    },
    d: "M65 339L66 340L65 339M165 340L165 345L166 345L165 340M235.333 340.667L235.667 341.333L235.333 340.667M432 341L433 342L432 341M63 342L64 343L63 342M61 345L62 346L61 345M234.333 346.667L234.667 347.333L234.333 346.667M431.333 346.667L431.667 347.333L431.333 346.667M58 350L59 351L58 350M57 352L58 353L57 352M430 352L431 353L430 352M233 353L234 354L233 353M55 355L56 356L55 355M54 357L55 358L54 357M429.333 357.667L429.667 358.333L429.333 357.667M53 359L54 360L53 359M166 359L166 364L167 364L166 359M232.333 359.667L232.667 360.333L232.333 359.667M52 361L53 362L52 361M428.333 363.667L428.667 364.333L428.333 363.667M50 364L51 365L50 364M112 364L113 365L112 364M111 365L112 366L111 365M231.333 365.667L231.667 366.333L231.333 365.667M49 366L50 367L49 366z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#fffff1",
      stroke: "none"
    },
    d: "M111 366C106.963 377.855 100.294 400.832 91 409L91 410L99 414L111.297 414.928L114.451 404L112.04 393L111 366z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#eaf185",
      stroke: "none"
    },
    d: "M48 368L49 369L48 368M427.333 368.667L427.667 369.333L427.333 368.667M296.105 369.851C290.221 371.672 293.295 379.287 298.938 377.353C304.445 375.465 301.215 368.27 296.105 369.851M337.318 370.086C333.201 372.389 336.497 378.805 340.852 376.712C345.583 374.439 341.531 367.731 337.318 370.086M47 370L48 371L47 370M109 370L110 371L109 370M167 371L167 392L168 392L167 371M230.333 371.667L230.667 372.333L230.333 371.667z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#23afb3",
      stroke: "none"
    },
    d: "M338 371L337 375L341 375L340 371L338 371z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#eaf185",
      stroke: "none"
    },
    d: "M46 372L47 373L46 372M108 372L109 373L108 372z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#23afb3",
      stroke: "none"
    },
    d: "M294 373L294 375L301 373L294 373z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#eaf185",
      stroke: "none"
    },
    d: "M107 374L108 375L107 374M426.333 374.667L426.667 375.333L426.333 374.667M229.333 377.667L229.667 378.333L229.333 377.667M43 378L44 379L43 378M105 379L106 380L105 379M425.333 379.667L425.667 380.333L425.333 379.667M42 380L43 381L42 380M104 381L105 382L104 381M103 383L104 384L103 383M228.333 383.667L228.667 384.333L228.333 383.667M102 385L103 386L102 385M424.333 385.667L424.667 386.333L424.333 385.667M40 386L41 387L40 386M39 389L40 390L39 389M100 390L101 391L100 390M227 390L228 391L227 390M423.333 390.667L423.667 391.333L423.333 390.667M38 392L39 393L38 392M99 392L100 393L99 392M98 394L99 395L98 394M166 394L167 395L166 394M37.3333 396.667L37.6667 397.333L37.3333 396.667M165 396L166 397L165 396M226.333 396.667L226.667 397.333L226.333 396.667M422.333 396.667L422.667 397.333L422.333 396.667M97 397L98 398L97 397M112 397L113 398L112 397M163 398L164 399L163 398M96 400L97 401L96 400M113 400L114 401L113 400M158.667 400.333L159.333 400.667L158.667 400.333M113 411C111.581 414.827 109.987 415.451 106 415L95 424L105 414L105 413L86 422L85 421L94 411C86.8161 407.961 82.1489 411.213 75 412.536C62.9862 414.76 44.0273 417.253 33 411L26 428C43.0226 436.545 65.5176 434.824 84 436.09C103.337 437.414 120.401 441.628 139 434C133.97 424.31 123.194 420.11 113 418L113 416L114 415C124.449 418.4 135.17 421.998 141 432C156.251 426.125 173.814 426.196 190 426.004C196.243 425.93 209.211 427.973 214.396 423.821C220.131 419.228 211.103 410.679 206.996 409.133C198.71 406.013 183.724 405.121 175.015 406.488C171.004 407.117 169.23 410.815 165 411L167 406L155 413L162 402C158.257 402.667 154.732 401.314 151 402.379C138.115 406.057 127.063 413.572 113 411M163 401L164 402L163 401z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#23afb3",
      stroke: "none"
    },
    d: "M155 413C160.618 412.092 163.635 407.261 165 402C159.559 403.527 155.867 407.379 155 413z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#eaf185",
      stroke: "none"
    },
    d: "M172 402L173 403L172 402M225.333 402.667L225.667 403.333L225.333 402.667M421 402L422 403L421 402M37.3333 403.667L37.6667 404.333L37.3333 403.667M95 403L96 404L95 403z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#2e2c2c",
      stroke: "none"
    },
    d: "M116 403C108.277 419.12 139.628 407.156 146 405L116 403M146.667 403.333L147.333 403.667L146.667 403.333z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#eaf185",
      stroke: "none"
    },
    d: "M165 403L166 404L165 403M170 403L169 405L170 403z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#23afb3",
      stroke: "none"
    },
    d: "M165 411C170.177 411.764 172.737 407.632 174 403C169.241 404.142 166.978 406.6 165 411z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#eaf185",
      stroke: "none"
    },
    d: "M174 404L175 405L174 404z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#2e2c2c",
      stroke: "none"
    },
    d: "M37 405L34 412C48.5765 416.934 67.2811 414.036 82 411L82 410C67.1105 410 50.1932 412.833 37 405z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#eaf185",
      stroke: "none"
    },
    d: "M114 405L115 406L114 405z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#23afb3",
      stroke: "none"
    },
    d: "M36 406L37 407L36 406z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#eaf185",
      stroke: "none"
    },
    d: "M94 406L95 407L94 406z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#23afb3",
      stroke: "none"
    },
    d: "M141 406L142 407L141 406z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#eaf185",
      stroke: "none"
    },
    d: "M35 407L36 408L35 407M93 407L94 408L93 407M420.333 407.667L420.667 408.333L420.333 407.667z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#23afb3",
      stroke: "none"
    },
    d: "M136 408L137 409L136 408M34 409L35 410L34 409z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#2e2c2c",
      stroke: "none"
    },
    d: "M82.6667 409.333L83.3333 409.667L82.6667 409.333z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#23afb3",
      stroke: "none"
    },
    d: "M132 409L133 410L132 409z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#eaf185",
      stroke: "none"
    },
    d: "M224 409L224 412L225 412L224 409M95 410L96 411L95 410z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#23afb3",
      stroke: "none"
    },
    d: "M85 421L86 422C91.4187 420.161 96.4834 416.165 99 411L98 410C92.5813 411.839 87.5166 415.835 85 421M127 410L128 411L127 410M79 411L80 412L79 411M115 411L116 412L115 411M120.667 411.333L121.333 411.667L120.667 411.333M34 412L35 413L34 412M75 412L76 413L75 412M39 413L40 414L39 413M65 413L65 414L68 414L65 413z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#eaf185",
      stroke: "none"
    },
    d: "M419 413L420 414L419 413z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#23afb3",
      stroke: "none"
    },
    d: "M51 414L51 415L54 415L51 414M95 424C100.319 422.617 104.48 419.372 106 414C100.681 415.383 96.5204 418.628 95 424M114.667 415.333L115.333 415.667L114.667 415.333z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#2e2c2c",
      stroke: "none"
    },
    d: "M113 416C116.262 420.344 123.362 420.67 128 423.363C135.334 427.623 138.545 433.323 141 441C150.879 427.889 122.506 416.203 113 416z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#eaf185",
      stroke: "none"
    },
    d: "M225 416L226 417L225 416z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#23afb3",
      stroke: "none"
    },
    d: "M115 418L116 419L115 418z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#eaf185",
      stroke: "none"
    },
    d: "M418 418L419 419L418 418z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#23afb3",
      stroke: "none"
    },
    d: "M124 421L125 422L124 421M126 422L127 423L126 422M132 422L133 423L132 422z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#eaf185",
      stroke: "none"
    },
    d: "M228 422L229 423L228 422M417 422L418 423L417 422z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#23afb3",
      stroke: "none"
    },
    d: "M128 423L129 424L128 423M130 424L131 425L130 424M142 431L143 438C160.369 433.261 179.008 433.088 197 433.001C202.682 432.973 214.421 435.035 218.288 429.586C223.704 421.954 203.493 425.851 201 425.961C181.483 426.815 160.817 424.983 142 431z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#eaf185",
      stroke: "none"
    },
    d: "M416 424L417 425L416 424z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#23afb3",
      stroke: "none"
    },
    d: "M136 425L137 426L136 425M137 426L138 427L137 426z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#eaf185",
      stroke: "none"
    },
    d: "M219 426L220 427L219 426M415 426L416 427L415 426z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#23afb3",
      stroke: "none"
    },
    d: "M138 427L139 428L138 427z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#eaf185",
      stroke: "none"
    },
    d: "M24 428L25 429L24 428z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#23afb3",
      stroke: "none"
    },
    d: "M141 442L140 434C133.147 435.218 127.129 438.42 120 438.91C98.6502 440.381 74.2802 436.347 53 433.95C46.6509 433.235 27.1504 425.878 22.6528 430.449C11.1403 442.148 35.9377 444.002 42 444C55.9306 443.996 68.9523 442.127 83 443.09C102.739 444.443 121.795 449.396 141 442z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#eaf185",
      stroke: "none"
    },
    d: "M234 428L235 429L234 428M218 430L219 431L218 430M238 430L239 431L238 430M21 431L22 432L21 431M216 431L217 432L216 431M241 431L242 432L241 431z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#23afb3",
      stroke: "none"
    },
    d: "M138 432L139 433L138 432z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#eaf185",
      stroke: "none"
    },
    d: "M213 432L214 433L213 432M252 432L252 433L261 433L252 432M20 433L21 434L20 433M174 433L175 434L174 433M189 433L189 434L203 434L189 433M284 433L284 434L293 434L284 433M408 433L409 434L408 433M158 434L158 435L166 435L158 434M315 434L315 435L325 435L315 434M406 434L407 435L406 434M150 435L150 436L153 436L150 435M347 435L347 436L356 436L347 435M404 435L405 436L404 435M147 436L148 437L147 436M379 436L379 437L388 437L379 436M399.667 436.333L400.333 436.667L399.667 436.333M145 437L146 438L145 437M143.333 438.667L143.667 439.333L143.333 438.667z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#23afb3",
      stroke: "none"
    },
    d: "M142 440L143 441L142 440z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#eaf185",
      stroke: "none"
    },
    d: "M60 441L61 442L60 441M25 442L26 443L25 442M68 442L68 443L73 443L68 442M139 442L140 443L139 442M29 443L29 444L32 444L29 443M51 443L51 444L55 444L51 443M81 443L81 444L87 444L81 443M137 443L138 444L137 443M93 444L93 445L96 445L93 444M134 444L135 445L134 444M100.667 445.333L101.333 445.667L100.667 445.333M129.667 445.333L130.333 445.667L129.667 445.333M106 446L106 447L123 447L106 446z"
  }));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDb1);
export default __webpack_public_path__ + "static/media/db1.9f32e2a17c4b4e1806dc393a3b065ae7.svg";
export { ForwardRef as ReactComponent };